import React from 'react';
import {
  Box,
  HStack,
  IconButton,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Link as ChakraLink,
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaNewspaper, FaChartLine, FaUser, FaList, FaBriefcase } from 'react-icons/fa';

const navItems = [
    { label: 'Market', to: '/dashboard/MarketAnalyzer', icon: FaChartLine },
    { label: 'News', to: '/dashboard/NewsAnalyzer', icon: FaNewspaper },
    { label: 'Portfolio', to: '/dashboard/ProfileAnalyzer', icon: FaBriefcase },
    { label: 'Watchlist', to: '/dashboard/watchlist', icon: FaList },

];

function LogOutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (e) {
      // ignore
    }
    navigate('/login');
  };

  return (
    <Box as="button" onClick={handleLogout} p={2} textAlign="left" borderRadius="md" _hover={{ bg: 'gray.50' }}>
      Log out
    </Box>
  );
}

const ResponsiveNav = () => {
  const location = useLocation();

  const isActive = (to) => location.pathname === to || location.pathname.startsWith(to);

  return (
    <Box
      display={{ base: 'block', md: 'none' }}
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      zIndex={50}
      boxShadow="sm"
    >
      <HStack px={3} py={2} justify="space-between" maxW="1200px" mx="auto">
        {navItems.map((item) => (
          <RouterLink key={item.to} to={item.to} style={{ textDecoration: 'none' }}>
            <Box textAlign="center">
              <IconButton
                aria-label={item.label}
                icon={<item.icon />}
                variant="ghost"
                size="lg"
                color={isActive(item.to) ? 'teal.500' : 'gray.600'}
                _hover={{ bg: 'transparent' }}
              />
              <Text fontSize="xs" color={isActive(item.to) ? 'teal.500' : 'gray.600'} mt={-1}>
                {item.label}
              </Text>
            </Box>
          </RouterLink>
        ))}

        {/* Profile item with submenu */}
        <Popover placement="top" isLazy>
          <PopoverTrigger>
            <Box textAlign="center">
              <IconButton
                aria-label="Profile"
                icon={<FaUser />}
                variant="ghost"
                size="lg"
                color={isActive('/dashboard/ProfileAnalyzer') ? 'teal.500' : 'gray.600'}
                _hover={{ bg: 'transparent' }}
              />
              <Text fontSize="xs" color={isActive('/dashboard/ProfileAnalyzer') ? 'teal.500' : 'gray.600'} mt={-1}>
                Profile
              </Text>
            </Box>
          </PopoverTrigger>
          <PopoverContent w="160px" mr={3} ml={3}>
            <PopoverBody p={2}>
              <VStack spacing={1} align="stretch">
                <ChakraLink as={RouterLink} to="/dashboard/pricing" p={2} borderRadius="md" _hover={{ bg: 'gray.50' }}>
                  My Plan
                </ChakraLink>
                <ChakraLink as={RouterLink} to="/dashboard/change-password" p={2} borderRadius="md" _hover={{ bg: 'gray.50' }}>
                  Change Password
                </ChakraLink>
                <LogOutButton />
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </HStack>
    </Box>
  );
};

export default ResponsiveNav;
